import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { SwiperSlide } from 'swiper/react';
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import SimpleCard from "../../../../Components/SimpleCard";
import Carousel from "../../../../Components/Carousel";

import { getActivityList } from "../../../../redux/actions/event";
import "./style.css";

const DetailTabs = ({ categoryList, activityList, setCategoryId, categoryId, event_id, ageRange, classRange, ageGrp, classGrp }) => {

  const dispatch = useDispatch();

  const [age, setAge] = useState(ageGrp);
  const [clas, setClas] = useState(classGrp);

  useEffect(() => {
    if (age) {
      const [min_age, max_age] = age?.split("-")
      dispatch(getActivityList({ category_id: categoryId, competition_id: event_id, min_age, max_age }))
    }
    if (clas) {
      const [min_class, max_class] = clas?.split("-")
      dispatch(getActivityList({ category_id: categoryId, competition_id: event_id, min_class, max_class }))
    }
    if (!age && !clas) {
      dispatch(getActivityList({ category_id: categoryId, competition_id: event_id }))
    }
  }, [age, clas])

  const handleChange = (key, e) => {
    setCategoryId(key);
    const [min_age, max_age] = age?.split("-");
    dispatch(getActivityList({ category_id: key, competition_id: event_id, min_age, max_age }))
  }

  const myBreakpoints = {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
  };
  return (
    <div className="detail-tabs px-5">
      <div className="paticipent chmp-narc-2022 d-flex justify-content-between mb-5">
        <p className="free-prtcipnt-text fw-semibold">
          For participants born on or between 2nd May 2017 &amp; 1st May 2018
        </p>
        <div className="chmpn-register-select-btn">
          {ageRange?.length > 0 && <select className="form-select chmpn-custom-selecter" onChange={(e) => setAge(e.target.value)} value={age}>
            {ageRange?.map((item, index) => <option value={`${item?.minimum}-${item?.maximum}`} key={index}>{item?.name}</option>)}
          </select>}
          {classRange?.length > 0 && <select className="form-select chmpn-custom-selecter" onChange={(e) => setClas(e.target.value)} value={clas}>
            {classRange?.map((item, index) => <option value={`${item?.minimum}-${item?.maximum}`} key={index}>{item?.name}</option>)}
          </select>}
        </div>
      </div>
      <div className="participent-skills-tab">
        <Tabs defaultActiveKey={categoryList?.[0]?.category_id} onSelect={handleChange} className="mb-3" id="fill-tab-example">
          {categoryList?.map((item, key) => {
            return (
              <Tab eventKey={item?.category_id} title={item?.category_name} key={key} >
                <Carousel breakpoints={myBreakpoints}>
                  {activityList?.map((activity, subKey) => <SwiperSlide key={subKey}><SimpleCard data={activity} event_id={event_id} /></SwiperSlide>)}
                </Carousel>
              </Tab>
            )
          })}
        </Tabs>
      </div>
    </div>
  );
};

export default DetailTabs;
